import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { Link as RouterLink } from 'react-router-dom';
import { getRegisteredToolKeys } from '../../pages/ToolPage/ToolPage';
import { isAdminOnlyTool } from '../../utils/toolAccessUtils';
import { rememberToolsReturnPath } from '../../utils/toolNavigationUtils';

export function MenuTools() {
  const user = JSON.parse(localStorage.getItem('user'));
  const registeredKeys = new Set(getRegisteredToolKeys());
  const tools = (user?.tools || [])
    .filter((tool) => registeredKeys.has(tool.key))
    // Admin-only entries (Tool Permissions) sink to the bottom, below real tools.
    .sort((a, b) => Number(isAdminOnlyTool(a.key)) - Number(isAdminOnlyTool(b.key)));

  if (!tools.length) {
    return null;
  }

  return (
    <NavDropdown title="Tools" drop="down" id="ToolsNavDropdown">
      {tools.map((tool) => (
        <NavDropdown.Item
          key={tool.key}
          to={`/tools/${tool.key}`}
          as={RouterLink}
          onClick={rememberToolsReturnPath}
        >
          {tool.title}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
}
